import React from 'react';

const Banner = () => {
  return (
    <div className='banner container mx-auto flex justify-center bg-cover items-center mb-12 px-6 md:px-0'>
      <div className='flex items-center flex-col md:ml-64'>
        <div className='text-nusblue text-xl text-center'>
          For further inquiries about L3 Short Courses at NUS Business School
        </div>
        <div className='text-nusblue text-xl text-center'>
          <a href='mailto:bizshortcourses@nus.edu.sg' className='underline'>
            bizshortcourses@nus.edu.sg
          </a>
        </div>
      </div>
    </div>
  );
};

export default Banner;
